import "core-js/modules/es.array.splice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Código',
        field: 'codigo',
        quickFilter: true,
        quickFilterSize: 'sm'
      }, {
        type: 'text',
        label: 'Nome',
        field: 'nome',
        quickFilter: true,
        quickFilterSize: 'xl',
        defaultFilterOperator: 3,
        filterOperators: [{
          value: 3,
          text: 'Contendo',
          summaryText: 'contém'
        }, {
          value: 1,
          text: 'Começando com',
          summaryText: 'começa com'
        }, {
          value: 2,
          text: 'Terminando com',
          summaryText: 'termina com'
        }]
      }, {
        type: 'text',
        label: 'Fantasia',
        field: 'nome_fantasia',
        filterSection: 'Identificação'
      }, {
        type: 'text',
        label: 'CPF/CNPJ',
        field: 'cnpj_cpf',
        quickFilter: true,
        quickFilterSize: 'md'
      }, {
        type: 'date',
        label: 'Data Cadastro',
        field: 'created_at',
        filterSection: 'Identificação'
      }, {
        type: 'text',
        label: 'Logradouro',
        field: 'logradouro',
        filterSection: 'Endereço'
      }, {
        type: 'text',
        label: 'Bairro',
        field: 'bairro',
        filterSection: 'Endereço'
      }, {
        type: 'text',
        label: 'Cidade',
        field: 'cidade',
        filterSection: 'Endereço'
      }, {
        type: 'text',
        label: 'UF',
        field: 'uf',
        filterSection: 'Endereço'
      }, {
        type: 'text',
        label: 'Profissão',
        field: 'profissao',
        filterSection: 'Identificação'
      }, {
        type: 'text',
        label: 'Telefone',
        field: 'fone',
        filterSection: 'Identificação'
      }, {
        type: 'text',
        label: 'Representante',
        field: 'representante',
        filterSection: 'Identificação'
      }, {
        type: 'select',
        label: 'Tipo',
        field: 'tipo',
        quickFilter: true,
        quickFilterSize: 'sm',
        options: ['Cliente', 'Fornecedor', 'Transportador', 'Todos']
      }]
    }
  }), _vm.canApplyListaPreco ? _c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }], null, false, 2976318409)
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.openListaDePrecoModal
    }
  }, [_vm._v("Aplicar Lista de preço ")])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "dadosClienteModal",
      "title": "Dados da pessoa:",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          on: {
            "click": function click($event) {
              {
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_vm.pessoaModal ? _c('label', [_vm._v(" Nome: " + _vm._s(_vm.pessoaModal.nome) + " "), _vm.pessoaModal.nome_fantasia ? _c('p', [_vm._v(" Fantasia: " + _vm._s(_vm.pessoaModal.nome_fantasia) + " ")]) : _vm._e(), _vm.pessoaModal.responsavel ? _c('p', [_vm._v(" Contato: " + _vm._s(_vm.pessoaModal.responsavel) + " ")]) : _vm._e(), _vm.pessoaModal.cnpj_cpf ? _c('p', [_vm._v(" CPF/CNPJ: " + _vm._s(_vm.formatarCampo(_vm.pessoaModal.cnpj_cpf)) + " ")]) : _vm._e(), _vm.pessoaModal.ie_rg ? _c('p', [_vm._v("IE/RG: " + _vm._s(_vm.pessoaModal.ie_rg))]) : _vm._e(), _vm.pessoaModal.fones.length > 0 ? _c('div', [_c('label', [_vm._v("Telefones: ")]), _vm._l(_vm.pessoaModal.fones, function (f, index) {
    return _c('p', {
      key: 'code' + index
    }, [_vm._v(" " + _vm._s(f.fone) + " "), _c('LinkPlus', {
      attrs: {
        "size": 20
      },
      on: {
        "click": function click($event) {
          return _vm.doCopy(f.fone);
        }
      }
    })], 1);
  })], 2) : _vm._e(), _vm.pessoaModal.emails.length > 0 ? _c('div', [_c('label', [_vm._v("Emails: ")]), _vm._l(_vm.pessoaModal.emails, function (e, index) {
    return _c('p', {
      key: 'code' + index
    }, [_vm._v(" " + _vm._s(e.email) + " "), _c('LinkPlus', {
      attrs: {
        "size": 20
      },
      on: {
        "click": function click($event) {
          return _vm.doCopy(e.email);
        }
      }
    })], 1);
  })], 2) : _vm._e(), _vm.pessoaModal.enderecos.length > 0 ? _c('div', [_c('label', [_vm._v("Endereços: ")]), _vm._l(_vm.pessoaModal.enderecos, function (e, index) {
    return _c('p', {
      key: 'code' + index
    }, [_vm._v(" " + _vm._s(_vm.formatEnderecoModal(e)) + " ")]);
  })], 2) : _vm._e(), _vm.pessoaModal.limite_credito > 0 ? _c('div', [_c('label', [_vm._v("Limite de crédito: ")]), _c('p', [_vm._v("R$ " + _vm._s(_vm.numberToReal(_vm.pessoaModal.limite_credito)))])]) : _vm._e(), _vm.pessoaModal.conta_receber_vencida ? _c('div', [_c('label', {
    staticClass: "label label-lg label-inline label-light-warning"
  }, [_vm._v("Cliente inadimplente")])]) : _vm._e()]) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "modalAnexo",
      "title": "Anexos",
      "centered": "",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', [_c('b-button', {
          ref: "salvarAnexos",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarAnexos
          }
        }, [_vm._v(" Salvar anexos ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: _vm.descricao_anexo,
      callback: function callback($$v) {
        _vm.descricao_anexo = $$v;
      },
      expression: "descricao_anexo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "anexo",
      "label": "Anexo"
    }
  }, [_c('b-form-file', {
    attrs: {
      "accept": ".jpg, .png, .pdf",
      "placeholder": "Selecione o anexo.."
    },
    on: {
      "change": function change(event) {
        return _vm.setAnexo(event);
      }
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-primary btn-bold",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmitAnexo
    }
  }, [_vm._v(" Adicionar ")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Descrição")]), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Anexo")]), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Ação")])])]), _c('tbody', _vm._l(_vm.anexos, function (a, index) {
    return _c('tr', {
      key: 'anexo_' + index
    }, [_c('td', [_vm._v(_vm._s(a.descricao))]), a.url && _vm.checkUrl(a.url) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      attrs: {
        "href": a.url,
        "target": "_blank"
      }
    }, [_vm._v(" Visualizar")])]) : _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v("Arquivo não armazenado")]), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_c('button', {
      staticClass: "btn btn-light-primary btn-sm btn-bold",
      on: {
        "click": function click() {
          _vm.$toast.error('Anexo excluído');
          _vm.anexos.splice(index, 1);
        }
      }
    }, [_c('TrashCan', {
      attrs: {
        "size": 16
      }
    })], 1)])]);
  }), 0)])])], 1)], 1), _c('TableApp', {
    ref: "pessoa",
    attrs: {
      "titulo": "Pessoas",
      "subTitulo": "Clientes / Fornecedores / Transportadoras",
      "acaoBtn": "/#/pessoas/nova",
      "textoBtn": "Novo",
      "api-url": "pessoa",
      "fields": _vm.fields,
      "classFilterColumn": "pessoa",
      "perPage": 10,
      "multiselect": true
    },
    scopedSlots: _vm._u([{
      key: "toolbar-actions",
      fn: function fn() {
        return [_c('CadastroEmpresaCopiarButton', {
          attrs: {
            "modulo": "PESSOA"
          }
        })];
      },
      proxy: true
    }, {
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'codigo' ? _c('span', {
          attrs: {
            "slot": "codigo"
          },
          slot: "codigo"
        }, [_c('span', {
          staticStyle: {
            "width": "110px"
          }
        }, [_c('div', {
          staticClass: "font-weight-bolder font-size-lg mb-0"
        }, [_vm._v(" " + _vm._s(props.rowData.codigo) + " ")])])]) : _vm._e(), props.field == 'nome' ? _c('span', {
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "symbol symbol-40 symbol-light-primary flex-shrink-0",
          staticStyle: {
            "margin-right": "10px"
          }
        }), _c('div', [_c('a', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Ver dados',
            expression: "'Ver dados'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg",
          on: {
            "click": function click($event) {
              return _vm.dadosCliente(props.rowData);
            }
          }
        }, [_vm._v(_vm._s(props.rowData.nome))]), _vm._l(props.rowData.pessoa_tipo, function (tipoPessoa) {
          return _c('span', {
            key: tipoPessoa.id_pessoa,
            staticClass: "text-muted font-weight-bold d-block"
          }, [_vm._v(_vm._s(tipoPessoa.tipo.descricao))]);
        })], 2)])])]) : _vm._e(), props.field == 'nome_fantasia' ? _c('span', {
          attrs: {
            "slot": "nome_fantasia"
          },
          slot: "nome_fantasia"
        }, [_c('span', {
          staticStyle: {
            "width": "110px"
          }
        }, [_c('div', {
          staticClass: "font-weight-bolder font-size-lg mb-0"
        }, [_vm._v(" " + _vm._s(props.rowData.nome_fantasia) + " ")])])]) : _vm._e(), props.field == 'fones' ? _c('span', {
          attrs: {
            "slot": "fones"
          },
          slot: "fones"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatFones(props.rowData.fones)) + " ")])])])]) : _vm._e(), props.field == 'enderecos' ? _c('span', {
          attrs: {
            "slot": "enderecos"
          },
          slot: "enderecos"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatEndereco(props.rowData.enderecos)) + " ")])])])]) : _vm._e(), props.field == 'cnpj_cpf' ? _c('span', {
          attrs: {
            "slot": "cnpj_cpf"
          },
          slot: "cnpj_cpf"
        }, [props.rowData.cnpj_cpf ? _c('span', {
          staticStyle: {
            "width": "110px"
          }
        }, [_c('div', {
          staticClass: "font-weight-bolder font-size-lg mb-0",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatarCampo(props.rowData.cnpj_cpf)) + " ")]), props.rowData.ie_rg ? _c('div', {
          staticClass: "font-weight-bold text-muted",
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v(" IE/RG: " + _vm._s(props.rowData.ie_rg) + " ")]) : _vm._e()]) : _vm._e()]) : _vm._e(), props.field == 'created_at' ? _c('span', {
          attrs: {
            "slot": "created_at"
          },
          slot: "created_at"
        }, [_c('span', {
          staticStyle: {
            "width": "110px"
          }
        }, [_c('div', {
          staticClass: "font-weight-bolder font-size-lg mb-0"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.created_at)) + " ")])])]) : _vm._e(), props.field == 'status' ? _c('span', {
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [props.rowData.status == 'A' ? _c('span', {
          staticClass: "label label-lg label-inline label-light-success"
        }, [_vm._v("Ativo")]) : _c('span', {
          staticClass: "label label-lg label-inline label-light-danger"
        }, [_vm._v("Inativo")])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Anexos',
            expression: "'Anexos'"
          }],
          staticClass: "btn btn-sm btn-primary btn-hover-primary btn-icon mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.modalAnexos(props.rowData);
            }
          }
        }, [_c('Folder', {
          attrs: {
            "size": 16
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Histórico',
            expression: "'Histórico'"
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.gerarHistoricoCliente(props.rowData);
            }
          }
        }, [_c('ChartBar', {
          attrs: {
            "size": 16
          }
        })], 1), _c('router-link', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Editar',
            expression: "'Editar'"
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "size": "sm",
            "to": {
              name: 'pessoasEditar',
              params: {
                id_pessoa: props.rowData.id_pessoa
              }
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Excluir',
            expression: "'Excluir'"
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)], 1)])])]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "modal-apply-lista-preco",
      "title": "Aplicar lista de preço para os clientes",
      "size": "md",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "aplicar_lista_preco",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.aplicarListaPreco
          }
        }, [_vm._v("Aplicar lista preço")])];
      }
    }])
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Lista de preço",
      "label-for": "listaPreco"
    }
  }, [_c('VueSelect', {
    ref: "listaPreco",
    attrs: {
      "filterable": false,
      "options": _vm.listasPreco
    },
    on: {
      "search": _vm.onSearchListaPreco
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.descricao))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(_vm._s(option.descricao))])];
      }
    }]),
    model: {
      value: _vm.listaPrecoSelected,
      callback: function callback($$v) {
        _vm.listaPrecoSelected = $$v;
      },
      expression: "listaPrecoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe a lista de preço pela descrição")])], 2)], 1)], 1)], 1), _c('b-row'), _c('div', {
    staticClass: "mx-auto"
  }, [_c('b-row', [_c('b-col', [_c('div', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Clientes: ")]), _vm._l(_vm.actionsStore.selectedRows, function (client) {
    return _c('p', {
      key: client.id
    }, [_vm._v(" " + _vm._s(client.nome) + " ")]);
  })], 2)])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };